// Polyfill for Object.hasOwn for browsers that don't support it
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn#browser_compatibility
import './object-has-own-polyfill';
